import React from 'react';
import { ReportsSection } from './sections';

export const LandingPage = () => {
  return (
    <>
      <ReportsSection />
    </>
  );
};
